import React from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { Message } from "primereact/message";

export const CvpFormErrors = () => {
  const formik = useFormikContext();

  if (formik.submitCount === 0) return null;

  const errors = Object.values(formik.errors);

  if (errors.length === 0) return null;

  return (
    <StyledCvpFormErrors
      severity="error"
      text={errors.map((error) => error).join(". ")}
    />
  );
};

const StyledCvpFormErrors = styled(Message)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  margin: 1rem 0;
`;
